import React, { Component } from 'react';

class Phases extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( 
        <div className="kwizda-phases">
            {this.props.actPhase ===1 && <h2>Adatok</h2>}
            {this.props.actPhase ===2 && <h2>Szabályzat</h2>}
            {this.props.actPhase ===3 && <h2>Kísérletek</h2>}
            {this.props.actPhase ===4 && <h2>Véglegesítés</h2>}
                <div className={(this.props.actPhase >= 1)? "kwizda-phase-selected": "kwizda-phase"}>
                    <div className="kwizda-phase-number">1</div>
                    <div className="kwizda-phase-name">Alap adatok megadása</div>
                </div> 
                <div className="kwizda-phase-arrow"> 
                    { (this.props.actPhase >= 2) ? <img alt="nyil" src="img/folyamat_nyil_aktiv.png"></img> : <img alt="nyil" src="img/folyamat_nyil_inaktiv.png"></img>} 
                </div>
                <div className={(this.props.actPhase >= 2)? "kwizda-phase-selected": "kwizda-phase"}>
                    <div className="kwizda-phase-number">2</div>
                    <div className="kwizda-phase-name">Szabályzat elfogadása </div>
                </div>
                <div className="kwizda-phase-arrow"> 
                    { (this.props.actPhase >= 3) ? <img alt="nyil" src="img/folyamat_nyil_aktiv.png"></img> : <img alt="nyil" src="img/folyamat_nyil_inaktiv.png"></img>} 
                </div>
                <div className={(this.props.actPhase >= 3)? "kwizda-phase-selected": "kwizda-phase"}>
                    <div className="kwizda-phase-number">3</div>
                    <div className="kwizda-phase-name">Kísérletválasztás</div>
                </div>
                <div className="kwizda-phase-arrow"> 
                    { (this.props.actPhase >= 4) ? <img alt="nyil" src="img/folyamat_nyil_aktiv.png"></img> : <img alt="nyil" src="img/folyamat_nyil_inaktiv.png"></img>} 
                </div>
                <div className={(this.props.actPhase >= 4)? "kwizda-phase-selected": "kwizda-phase"}>
                    <div className="kwizda-phase-number">4</div>
                    <div className="kwizda-phase-name">Regisztráció véglegesítése</div>
                </div>
        </div> );
    }
}
 
export default Phases;